import { render } from "./BoundingBoxCoordinateCanvas.vue?vue&type=template&id=60a0cfe2&scoped=true"
import script from "./BoundingBoxCoordinateCanvas.vue?vue&type=script&lang=js"
export * from "./BoundingBoxCoordinateCanvas.vue?vue&type=script&lang=js"

import "./BoundingBoxCoordinateCanvas.vue?vue&type=style&index=0&id=60a0cfe2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a0cfe2"]])

export default __exports__